import React from 'react';
import ExternalSourcePicker from '../../external-sources/components/ExternalSourcePicker';

const LINK_OPTIONS = [
  { key: 'WordPress', label: 'WordPress' },
  { key: 'Faicon', label: 'FAICON' },
  { key: 'None', label: 'Not linked' },
];

const LinkSourceToggle = ({ source, onChange }) => (
  <div className="upload-field">
    <span className="upload-label">Link to</span>
    <div className="upload-segmented" role="radiogroup">
      {LINK_OPTIONS.map((option) => (
        <button
          key={option.key}
          type="button"
          role="radio"
          aria-checked={source === option.key}
          className={source === option.key ? 'active' : ''}
          onClick={() => onChange(option.key)}
        >
          {option.label}
        </button>
      ))}
    </div>
  </div>
);

/** The "Session" card: which WordPress/FAICON session it belongs to, title and description. */
export default function SessionDetailsCard({ form }) {
  return (
    <section className="upload-card">
      <h2>Session</h2>
      <LinkSourceToggle source={form.source} onChange={form.changeSource} />

      {form.source !== 'None' && (
        <div className="upload-field">
          <ExternalSourcePicker
            key={form.source}
            source={form.source}
            showSourceToggle={false}
            onSelectionChange={form.changeLink}
          />
        </div>
      )}

      <label className="upload-field">
        <span className="upload-label">Title *</span>
        <input className="upload-input" value={form.title} onChange={(e) => form.setTitle(e.target.value)} placeholder="Session title" />
      </label>
      <label className="upload-field">
        <span className="upload-label">Description</span>
        <input className="upload-input" value={form.description} onChange={(e) => form.setDescription(e.target.value)} placeholder="Optional" />
      </label>
    </section>
  );
}
